import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type LeaguesV2State = {
  selectedLeagueId: string | null;
  selectedRoundId: string | null;
};

const initialState: LeaguesV2State = {
  selectedLeagueId: null,
  selectedRoundId: null,
};

const leaguesV2Slice = createSlice({
  name: "leaguesV2",
  initialState,
  reducers: {
    setSelectedLeagueId(state, action: PayloadAction<string | null>) {
      state.selectedLeagueId = action.payload;
    },
    setSelectedRoundId(state, action: PayloadAction<string | null>) {
      state.selectedRoundId = action.payload;
    },
    clearLeaguesV2(state) {
      state.selectedLeagueId = null;
      state.selectedRoundId = null;
    },
  },
});

const { actions, reducer: leaguesV2Reducer } = leaguesV2Slice;
const { setSelectedLeagueId, setSelectedRoundId, clearLeaguesV2 } = actions;

export {
  leaguesV2Reducer,
  setSelectedLeagueId,
  setSelectedRoundId,
  clearLeaguesV2,
};
